// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__bv16B","legalNotice":"Footer_legalNotice__H2Bj6"};